import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { isConnectPending } from '../../utils/connectModel';

// Owner, 2026-09-25: a company born Pending is pushed to Stripe from every
// page, not only the dashboard, and the push cannot be dismissed. It takes no
// card payment until the admin activates it, so the band says exactly that;
// once Stripe has what it needs, the band stops asking and says what happens
// next. It sits in layout.js's sticky slot, under the payout-paused band.
//
// The button is for the roles that can open Business Details (router.js and
// the Finance menu both gate it to 150 and 200); anyone else reads the same
// sentence without a button that would lead nowhere.
const FINISH_ROLES = [150, 200];

const ConnectPendingBand = ({ status, roles }) => {
  if (!isConnectPending(status)) return null;

  if (status?.connectStatus === 'READY') {
    return (
      <div role="status" className="border-b border-slate-200 bg-slate-50 px-4 py-2.5 dark:border-slate-700 dark:bg-slate-800/60">
        <div className="flex items-center justify-center gap-2.5">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-300">
            <ClockIcon className="h-4 w-4" aria-hidden="true" />
          </span>
          <p className="text-sm font-medium text-slate-800 dark:text-slate-100">
            Your Stripe setup is complete. We'll turn on card payments soon.
          </p>
        </div>
      </div>
    );
  }

  const canFinish = (roles || []).some((role) => FINISH_ROLES.includes(role));
  return (
    <div role="status" className="border-b border-amber-200 bg-amber-50 px-4 py-2.5 dark:border-amber-500/30 dark:bg-amber-500/10">
      <div className="flex flex-wrap items-center justify-center gap-2.5">
        <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300">
          <ExclamationTriangleIcon className="h-4 w-4" aria-hidden="true" />
        </span>
        <p className="text-sm font-medium text-amber-900 dark:text-amber-100">
          Complete your account setup to start accepting card payments.
        </p>
        {canFinish ? (
          <Link
            to="/dashboard/finance/business-details"
            className="rounded-md bg-amber-600 px-3 py-1 text-xs font-semibold text-white hover:bg-amber-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 dark:bg-amber-500 dark:text-slate-900 dark:hover:bg-amber-400"
          >
            Finish setup
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default ConnectPendingBand;
